// extracted by mini-css-extract-plugin
export var fadeIn = "_96-0";
export var panelInner = "_96-2";
export var panelOuter = "_96-1";